import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IconBook, IconCreditCard, IconKey, IconSparkles } from '@tabler/icons-react';

function ComingSoon() {
  useEffect(() => {
    document.title = 'PromptSlate | Prompt management and version control made easy';
  }, []);
  return (
    <div className="flex flex-col w-full items-center h-fit">
      <div className="w-full h-[45px] flex justify-center border-b">
        <div className="w-full max-w-5xl h-full flex items-center justify-between text-sm">
          <div>Introducting PromptSlate</div>
          <Link to="/signup">
            <div className="flex flex-row">
              Get started now <IconSparkles size="1rem" className="ml-2 mt-0.5" />
            </div>
          </Link>
        </div>
      </div>
      <div className="w-full max-w-5xl mt-2 mb-12">
        <div className="w-full max-w-5xl h-[70px] flex items-center justify-between">
          <div>
            <Link to="/">
              <img
                src="/logo_black.png"
                alt="PromptSlate logo"
                className="h-[30px] object-contain"
              />
            </Link>
          </div>
          <div className="flex flex-row">
            <div className="flex flex-row mr-5 p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
              <IconBook size="1.5rem" className="mr-1" /> Docs
            </div>
            <Link to="/pricing">
              <div className="flex flex-row mr-4 p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
                <IconCreditCard size="1.5rem" className="mr-1" /> Pricing
              </div>
            </Link>
            <Link to="/login">
              <div className="flex flex-row p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
                <IconKey size="1.5rem" className="mr-1" /> Login
              </div>
            </Link>
          </div>
        </div>
        <div className="mt-12">
          <div className="max-w-[50%] text-5xl font-semibold leading-[55px]">Coming soon.</div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
